module.exports = __webpack_public_path__ + "static/media/login-banner1.7de6f5af.jpg";